<template>
    <div class="hello" style="overflow:hidden;height:100%;display:flex;flex-direction: column;justify-content: space-between;">
      <div class="wrapper" id='chat' style="overflow:auto;" ref="chatContainer">
          <table border="0" cellpadding="0" cellspacing="0"  style="width:100%;">
              <template v-for="(v,k) in msgList">
              <tr  class="info" v-if='v.type == 1'>
                  <td>系统</td><td>{{v.msg}}</td><td class="bordernone"></td>
              </tr>
              <tr class="me" v-else-if="v.type==2">
                  <td></td>
                  <td v-if='v.img' style="text-align:right;" class="bordernone">
                  
                      <video v-if="v.img.indexOf('.mp4') != -1" controls type="video/mp4" style="max-width: 400px;width:80%;" :src="v.img" />    
                      <img v-else style="max-width: 400px;width:80%;" @click="view(v.img)" :src="v.img" />
  
                  </td>
                  <td v-else @click="dbclick(v.msg)" style="text-align:left;white-space: pre-line;float:right;" class="bordernone" v-html="v.msg"></td>
                  <td>{{v.time}}</td>
              </tr>
              <tr class="user" v-else-if="v.type==3">
                  <td>{{v.time}}</td>
                  <td v-if='v.img'>
                      <video v-if="v.img.indexOf('.mp4') != -1" controls type="video/mp4" style="max-width: 400px;width:80%;" :src="v.img" />    
                      <img v-else style="max-width: 400px;width:80%;" @click="view(v.img)" :src="v.img" />
                  </td>
                  <td v-else @click="dbclick(v.msg)" v-html="v.msg" style="text-align:left;white-space: pre-line;"></td>
                  <td class="bordernone"></td>
              </tr>
          </template>
          </table>
      </div>
      <div>
      <div class="bg color p5" v-if="cited" v-html="cited" @click="cleardbclick"></div>
  
      <div class="footer flex">
              <textarea @click="textareadbclick" rows="3" @keyup.enter="submit" v-model="text" placeholder="回车键发送消息，双击输入框可以刷新页面" @focus="focusin()" @keydown="keydowndo"></textarea>
  
          <div class='uploader'>
              <van-uploader :after-read="afterRead" :max-size="max" @oversize="onOversize" accept="video/mp4,image/*">
                  <i v-if="uploadfinish" class="van-icon van-icon-photograph van-uploader__upload-icon"><!----></i>
                  <i v-else>上传中。。。</i>
                  <!-- <van-icon name="plus" /> -->
              <!-- <van-button icon="plus" color="#60ac39" type="primary" size="medium">发送图片</van-button> -->
              </van-uploader>
          </div>
      </div>
  </div>
  
    </div>
  </template>
  
  <script>
  import { ImagePreview } from 'vant'
  import { Toast } from 'vant'
  import axios from 'axios';
  export default {
    name: 'hello',
    data(){
      return {
          textShow:true,
          fileList:[],
          show:true,
          text:'',
          name:'',
          img:'',
          msgList:[
          ],
          uploadfinish:true,
          max:1024*1024*200,
          socket:null,
          path:'',
          uploadurl:'',
          ssid:'',
          host:'',
          timer:null,
          timeoutval:null,
          times:0,
          verClickNum:1,
          clickTimer:null,
          lastClickTime:0,
          cited:'',
          reconnectAttempts: 0, // 当前重连次数
          maxReconnectAttempts: 5 // 最大重连次数
      }
    },
    created(){
      this.host = this.getUrlKey('host',window.location.href)
      let max = this.getUrlKey('max',window.location.href)
      if(max) this.max = max
    },
    mounted(){
      this.name = Math.floor(Math.random()*10000+1000)
      let domain = this.host?this.host:document.domain
      this.path = 'wss://'+domain+'/wss?name='+this.name+"&path="+this.getUrlPara()
      this.uploadurl = 'https://'+domain+'/upload'
      //
      this.init()
    },
    watch: {
      // 监听消息数组的变化
      msgList: {
        deep: true,
        handler() {
          this.$nextTick(() => {
            // 在DOM更新后调用滚动方法
            this.scrollToBottom();
          });
        },
        immediate:true
      }
    },
    methods:{
        reconnect() {
            if (this.reconnectAttempts >= this.maxReconnectAttempts) {
            this.notice(`已尝试连接 ${this.maxReconnectAttempts}次，仍然无法连接服务器，请稍后再试`);
            return;
            }
            this.reconnectAttempts++;
            setTimeout(() => {
            this.init(); // 尝试重新连接
            this.notice(`尝试重新连接 (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
            }, 1000); // 间隔 1 秒
        },
      getUrlKey(name,url){
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
      heart(){
          setInterval(() => {
              this.socket.send('{"type":6,"name":"ping"}')
          }, 10000);
      },
      getUrlPara()
      {
          return document.location.pathname.substr(1);
      },
      init: function () {
        if (typeof WebSocket === "undefined") {
            Toast("您的浏览器不支持socket");
        } else {
            this.socket = new WebSocket(this.path);
            this.socket.onopen = () => {
            this.open();
            this.reconnectAttempts = 0; // 重置重连次数
            };
            this.socket.onerror = this.error;
            this.socket.onclose = this.reconnect; // 添加重连逻辑
            this.socket.onmessage = this.getMessage;
        }
      },
      onOversize(file) {
        this.notice('图片太大了，达到了'+file.file.size/1024+'kb！不要超过'+this.max/1024+'kb');
      },
      focusin(){
          this.scrollToBottom();
          document.title = "Hack";
          clearTimeout(this.timer);        
      },
      keydowndo:function(){
          let send = {
                  type:8,
                  name:this.name
              }
          this.send(send)
          clearTimeout(this.timeoutval)
          this.cancelkeydow()
      },
      cancelkeydow:function() {
          this.timeoutval = setTimeout(() => {
              let send = {
                  type:9,
                  name:this.name
              }
          this.send(send)  
          }, 10000);
      },
      scrollToBottom() {
          setTimeout(() => {
              let container = this.$refs.chatContainer;
              container.scrollTop = container.scrollHeight;
          }, 150);
      },
      afterRead (file) {
  
          this.uploadfinish = false
  
          let f = file.file
          // 创建form对象
          let formdata1 = new FormData();
          // 通过append向form对象添加数据,可以通过append继续添加数据
          //或formdata1.append('file',file);
          formdata1.append('myfile', f, f.name);
          //设置请求头
          let config = {
              headers:{
                  'Content-Type':'multipart/form-data'
              }
          };  
          //this.axios 是因为在main.js写在vue实例里
          const axiosAjax = axios.create({
              timeout: 1000 * 60, //时间
              // withCredentials: true //跨域携带cookie
          });
          axiosAjax.post(this.uploadurl,formdata1,config).then((res)=>{   //这里的url为后端接口
              let data = [this.cited,res.data.data];
              let obj = {
                  type:3,
                  msg:JSON.stringify(data),
                  img:res.data.data
              }
              this.send(obj)
              this.uploadfinish = true
  
          }).catch(() => {})
      },
      open:function () {
          this.notice("连接服务器成功，现在可以发送消息")
          this.bind()
          this.heart()
      },
      error:function () {
          this.notice("连接服务器出错")
      },
      getMessage:function (msg) {
          let obj = JSON.parse(msg.data)
          if(obj.type == 7){
              this.msgList = obj.data;
              return;
          }
          if(obj.type == 6){
              return;
          }
  
          if(obj.type == 5)
          {
              return this.notice(obj.msg)
          }
          this.msgList.push(obj)
          
          if(obj.img && obj.type==3)
          {
              let send = {
                  type:5,
                  toName:obj.name
              }
              this.send(send)
          }
          if(obj.type==3)
          {
              clearTimeout(this.timer)
              this.twinkling()
          }
          if(obj.type==8)
          {
              clearTimeout(this.timer)
              document.title = obj.msg
          }
          if(obj.type==9)
          {
              clearTimeout(this.timer)
              document.title = "Hack"
          }
      },
      twinkling:function(){
          document.title = "新消息"
          this.timer = setTimeout(()=>{  
              this.twinkling()
              this.times++;  
              if (this.times % 2 == 0) {  
                  document.title = "Hack"
              }else{  
                  document.title = "新消息"
              };  
          }, 200); 
      },
      send:function (obj) {
          let str = JSON.stringify(obj)
          this.socket.send(str)
      },
      bind(){
          this.send({type:4,name:this.name})
      },
      close:function () {
        this.notice("已经断开连接");
        this.reconnect(); // 调用重连方法
      },
      view(path){
          ImagePreview([path]);
      },
      beforeClose(action, done) {
        if (action === 'confirm') {
          if(this.checkNull(this.name)){
              done()
              this.init()
          }else{
              done(false)
          }
        } else {
          this.name = ''
          this.show=false
          done()
          this.notice('取消了输入，停止接入服务器，刷新重试')
        }
      },
      submit(){
          if(this.socket.readyState != 1)
          {
              this.init()
              return this.notice('已经断开连接，正在重新连接')
          }
          if(!this.checkNull(this.text)) return
          this.sendMsg()
      },
      checkNull(obj){
          obj=obj.replace(/\ +/g,"")//去掉空格
          obj=obj.replace(/[ ]/g,"")  //去掉空格
          obj=obj.replace(/[\r\n]/g,"")//去掉回车换行
  
          if(!obj)
          {
              this.text = ''
              Toast('内容为空')
              return false
          }
          return true
      },
      sendMsg(){
          let data = [this.cited,this.text];
          let obj = {
              type:3,
              msg:JSON.stringify(data),
              img:this.img
          }
          this.send(obj)
          this.text=''
          this.img=''
          this.cited=''
      },
      dbclick(msg){
              var nowTime = new Date().getTime();
              if (nowTime - this.lastClickTime < 300) {
                  /*双击*/
                  this.cited = msg
                  this.verClickNum++;
                  this.lastClickTime = 0;
                  this.clickTimer && clearTimeout(this.clickTimer);
              } else {
                  /*单击*/
                  this.lastClickTime = nowTime;
                  this.clickTimer = setTimeout(function () {
                      if(this.verClickNum > 1){
                          this.verClickNum = 1;
                          return;
                      } else {
                      }
                  }, 300);
              }
      },
      cleardbclick(){
          var nowTime = new Date().getTime();
          if (nowTime - this.lastClickTime < 300) {
              /*双击*/
              this.cited = ''
              this.verClickNum++;
              this.lastClickTime = 0;
              this.clickTimer && clearTimeout(this.clickTimer);
          } else {
              /*单击*/
              this.lastClickTime = nowTime;
              this.clickTimer = setTimeout(function () {
                  if(this.verClickNum > 1){
                      this.verClickNum = 1;
                      return;
                  } else {
                  }
              }, 300);
          }
  },
      textareadbclick(msg){
              var nowTime = new Date().getTime();
              if (nowTime - this.lastClickTime < 300) {
                  /*双击*/
                  Toast('检测到双击行为，页面正在刷新中。。。')
                  setTimeout(() => {
                      window.location.href = ''
                  },500);
                  this.verClickNum++;
                  this.lastClickTime = 0;
                  this.clickTimer && clearTimeout(this.clickTimer);
              } else {
                  /*单击*/
                  this.lastClickTime = nowTime;
                  this.clickTimer = setTimeout(function () {
                      if(this.verClickNum > 1){
                          this.verClickNum = 1;
                          return;
                      } else {
                      }
                  }, 300);
              }
      },
      notice(msg){
          let obj = {
              type:1,
              msg:msg,
              name:'',
              img:''
          }
          this.msgList.push(obj)
          Toast(msg)
      }
  
    }
  
  }
  </script>
  
  <style scoped>
  .p5{
      padding:3px 3px 3px 5px
  }
  .color{
      color: #a6a28c;
  }
  .flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  table,div,td,tr{
      word-wrap: break-word;
  }
  .wrapper{
      padding: 2px;
  }
  .wrapper,.footer{
      color: #fff;
      font-size: 14px;
  }
  td img{
      width: 100%;
  }
  .user td:first-child{
      color: #B854D4;
  }
  .me td:last-child{
      color: #6684e1;
  }
  .footer{
      background:#20201D;
        border-style:none;
        width: 100%;
        box-sizing: border-box;
        border-top: 1px solid #a6a28c;
        /* padding-right: 10px; */
        height:auto;
  }
  .wrapper .info td{
      color:#60ac39;
  }
  .textarea{
        /* margin-right: 5px; */
        flex: 1;
  }
  textarea{
        background:transparent;
        border-style:none;
        width: 100%;
        box-sizing: border-box;
        border-right: 1px solid #a6a28c;
        padding:5px;
        resize:none;
  }
  /*table tr{
      padding: 3px;
  }*/
  table td{
      padding: 5px 3px;
      border-left: 1px solid #a6a28c;
  }
  table tr td:last-child{
      color: #a6a28c;
      width: 30px;
  }
  table tr td:first-child{
      width: 30px;
      color: #a6a28c;
      border:none;
  }
  table{
      color:#a6a28c;
  }
  .bordernone{
      border:none;
  }
  .uploader{
      padding:5px;
  }
  .bg{
      background-color: #4a4a4a;
  }
  .inlineblock{
      display: inline-block;
  }
  </style>
  
  